import { render, staticRenderFns } from "./ClipboardAlert.vue?vue&type=template&id=504797ae&"
import script from "./ClipboardAlert.vue?vue&type=script&lang=js&"
export * from "./ClipboardAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports